export class FindFilesInfoResult {
    fileList = [];
}
